import React from 'react';
import { ChevronDown } from 'lucide-react';

const TabNavigation = ({ tabs, activeTab, onTabSelect }) => {
  const [dropdownOpen, setDropdownOpen] = React.useState(false);

  const handleTabSelect = (tabId) => {
    onTabSelect(tabId);
    setDropdownOpen(false);
  };

  return (
    <>
      {/* Desktop Tab Navigation */}
      <div
        style={{
          maxWidth: '600px',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'center',
          gap: '48px',
          borderBottom: '1px solid var(--border-light)',
          paddingBottom: '0'
        }}
        className="desktop-tabs"
      >
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabSelect(tab.id)}
            style={{
              background: 'none',
              border: 'none',
              padding: '16px 0',
              cursor: 'pointer',
              fontFamily: 'Raleway, sans-serif',
              fontSize: '16px',
              fontWeight: activeTab === tab.id ? 500 : 400,
              color: activeTab === tab.id ? 'var(--burgundy)' : 'var(--text-secondary)',
              position: 'relative',
              transition: 'all 0.2s ease',
              borderBottom: activeTab === tab.id ? '2px solid var(--burgundy)' : '2px solid transparent'
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Mobile Dropdown Navigation */}
      <div className="mobile-dropdown" style={{ maxWidth: '400px', margin: '0 auto' }}>
        <button
          onClick={() => setDropdownOpen(!dropdownOpen)}
          style={{
            width: '100%',
            padding: '16px 20px',
            background: 'var(--ivory)',
            border: '1px solid var(--border-light)',
            borderRadius: '0',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            cursor: 'pointer',
            fontFamily: 'Raleway, sans-serif',
            fontSize: '16px',
            fontWeight: 500,
            color: 'var(--text-primary)'
          }}
        >
          {tabs.find(tab => tab.id === activeTab)?.label}
          <ChevronDown
            size={20}
            style={{
              transition: 'transform 0.2s ease',
              transform: dropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'
            }}
          />
        </button>

        {dropdownOpen && (
          <div
            style={{
              border: '1px solid var(--border-light)',
              borderTop: 'none',
              background: 'var(--ivory)',
              boxShadow: '0 4px 8px rgba(0,0,0,0.05)'
            }}
          >
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => handleTabSelect(tab.id)}
                style={{
                  width: '100%',
                  padding: '14px 20px',
                  background: activeTab === tab.id ? 'var(--bg-subtle)' : 'transparent',
                  border: 'none',
                  textAlign: 'left',
                  cursor: 'pointer',
                  fontFamily: 'Raleway, sans-serif',
                  fontSize: '15px',
                  color: activeTab === tab.id ? 'var(--burgundy)' : 'var(--text-primary)',
                  fontWeight: activeTab === tab.id ? 500 : 400,
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  if (activeTab !== tab.id) {
                    e.target.style.background = 'var(--bg-subtle)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (activeTab !== tab.id) {
                    e.target.style.background = 'transparent';
                  }
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default TabNavigation;
